<template>
  <v-navigation-drawer color="black" v-model="drawer" app width="250">
    <v-list>
      </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item to="/app/dashboard" prepend-icon="mdi-home">
        <v-list-item-title>Home</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('imoveis')"
        to="/app/imoveis"
        prepend-icon="mdi-home-city-outline"
        :disabled="!hasPermission('imoveis')"
        :class="{ 'disabled-item': !hasPermission('imoveis') }"
      >
        <v-list-item-title>Imóveis</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('clientes')"
        to="/app/clientes"
        prepend-icon="mdi-account-group"
        :disabled="!hasPermission('clientes')"
        :class="{ 'disabled-item': !hasPermission('clientes') }"
      >
        <v-list-item-title>Clientes</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('corretores')"
        to="/app/corretores"
        prepend-icon="mdi-account-tie"
        :disabled="!hasPermission('corretores')"
        :class="{ 'disabled-item': !hasPermission('corretores') }"
      >
        <v-list-item-title>Corretores</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('videos')"
        to="/app/videos"
        prepend-icon="mdi-school-outline"
        :disabled="!hasPermission('videos')"
        :class="{ 'disabled-item': !hasPermission('videos') }"
      >
        <v-list-item-title>Videos</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('modelos-documento')"
        to="/app/modelos-documento"
        prepend-icon="mdi-note-text-outline"
        :disabled="!hasPermission('modelos-documento')"
        :class="{ 'disabled-item': !hasPermission('modelos-documento') }"
      >
        <v-list-item-title>Modelos Documentos</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('usuarios')"
        to="/app/usuarios"
        prepend-icon="mdi-account"
        :disabled="!hasPermission('usuarios')"
        :class="{ 'disabled-item': !hasPermission('usuarios') }"
      >
        <v-list-item-title>Usuários</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('empresa')"
        to="/app/empresa"
        prepend-icon="mdi-domain"
        :disabled="!hasPermission('empresa')"
        :class="{ 'disabled-item': !hasPermission('empresa') }"
      >
        <v-list-item-title>Empresa</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const drawer = ref(false);

    const userPermissions = computed(() => store.getters.getPermissions);

    const hasPermission = (permissionIdentifier) => {
      return Array.isArray(userPermissions.value) && userPermissions.value.includes(permissionIdentifier);
    };

    const toggleDrawer = () => {
      drawer.value = !drawer.value;
    };

    return { drawer, toggleDrawer, hasPermission };
  },
};
</script>

<style>
/* Estilos para o item de menu desabilitado */
.disabled-item {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}

/* Opcional: Para o texto e ícone manterem a cor desejada quando desabilitado */
.disabled-item .v-list-item-title,
.disabled-item .v-icon {
  color: #666 !important;
}

/* seu estilo existente */
.submenu-recuo .v-list-item {
  padding-left: 35px !important;
}
</style>